module.exports = __webpack_public_path__ + "img/telegram-hover.0256aefb.svg";